import { execFile } from "node:child_process";

export function openBrowser(url: string): void {
	// Launching is best-effort — the URL is also printed as a manual fallback —
	// so pass a no-op callback to swallow ENOENT/spawn errors instead of leaving
	// them unhandled.
	const ignore = (): void => {};
	if (process.platform === "darwin") {
		execFile("open", [url], ignore);
	} else if (process.platform === "win32") {
		execFile("cmd.exe", ["/c", "start", "", url], ignore);
	} else {
		execFile("xdg-open", [url], ignore);
	}
}
